import { apiFuns } from "sw-hic";

const api = {
  Log: {
    ...apiFuns.genStandard("searchLog", "/api/datacenter"),
  },
};

export default api;
